/** A sheet dragged down this fraction of its height, or this many px, whichever is less, is closed. */
const CLOSE_FRACTION = 0.25;
const CLOSE_PX = 100;
/** A flick faster than this (px per ms) closes it too, once it has gone a few px: a tap's jitter is quick but short. */
const FLICK_VELOCITY = 0.5;
const FLICK_MIN_PX = 24;

/** Whether letting go of a sheet that was dragged `dragPx` down, moving at `velocity` px/ms, closes it rather than snaps it back. */
export const shouldCloseSheet = (dragPx: number, heightPx: number, velocity: number): boolean =>
	dragPx > Math.min(heightPx * CLOSE_FRACTION, CLOSE_PX) || (dragPx > FLICK_MIN_PX && velocity > FLICK_VELOCITY);
